import { Settings2 } from "lucide-react";
import { PermissionEnum } from "@dashboard/graphql";
import { sectionNames } from "@dashboard/intl";

export const globalVariantsMenuItem = intl => ({
  description: "Bulk edit all global product variants across your catalog.",
  icon: <Settings2 size={32} />,
  permissions: [PermissionEnum.MANAGE_PRODUCTS],
  title: "Edit Global Variants",
  url: "/products/variants/bulk-edit-global-variants",
  testId: "configuration-menu-edit-global-variants",
});
